import PropTypes from 'prop-types'
import * as Sc from './Footer.style'

const Footer = ({ children, className }) => (
  <Sc.Container className={className}>{children}</Sc.Container>
)

Footer.defaultProps = {
  children: null,
  className: null,
}

Footer.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
}

export default Footer
